<template>
  <div class="asd20-tab-bar" :aria-label="ariaLabel">
    <asd20-tab
      v-for="(tab, index) in tabs"
      :key="index"
      v-bind="tab"
      @click.native="$emit('tabClick', tab)"
    />
    <slot />
  </div>
</template>

<script>
import Asd20Tab from '../../../components/molecules/Asd20Tab'
export default {
  name: 'Asd20TabBar',

  components: { Asd20Tab },

  props: {
    tabs: { type: Array, default: () => [] },
    ariaLabel: { type: String, default: 'Tab List' },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';

.asd20-tab-bar {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  flex-shrink: 0;
  background: var(--color__tertiary);
  padding: space(0.5) space(0.75) 0 space(0.75);
  overflow-x: auto;
}
</style>
